
(function () {
  if (window.__JNCardInit) return;
  window.__JNCardInit = true;

  // -------------------- CACHES --------------------
  const PRODUCT_JSON = new Map();      // handle -> Promise<Product>
  const WARMED = new Set();            // warmed image URLs
  const WIDTH_CACHE = new Map();   // card -> px width
  const IN_FLIGHT = new WeakMap();     // card -> AbortController
  //const money = (c) => { try { return Shopify.formatMoney(c, window.theme?.moneyFormat || "${{amount}}"); } catch { return `$${(c/100).toFixed(2)}`; } };

  // -------------------- HELPERS -------------------
  function measureCardWidth(card) {
    let w = WIDTH_CACHE.get(card);
    if (!w) {
      const primary = card.querySelector('.product-card__image--primary') || card.querySelector('img');
      w = Math.ceil(((primary?.getBoundingClientRect().width) || 360) * (window.devicePixelRatio || 1));
      WIDTH_CACHE.set(card, w);
    }
    return Math.min(Math.max(w, 320), 1600);
  }

  function sizeUrl(rawUrl, card) {
    if (!rawUrl) return rawUrl;
    try {
      const u = new URL(rawUrl, location.origin); // supports absolute and //-relative
      if (!u.searchParams.has('width')) u.searchParams.set('width', String(measureCardWidth(card)));
      return u.toString();
    } catch { return rawUrl; }
  }

  function warmImage(url) {
    if (!url || WARMED.has(url)) return;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.loading = 'eager';
    img.src = url;
    WARMED.add(url);
  }

  async function getProductJSON(handle, signal) {
    let p = PRODUCT_JSON.get(handle);
    if (!p) {
      p = fetch(`/products/${handle}.js`, { signal, credentials: 'same-origin' })
            .then(r => { if (!r.ok) throw new Error(`JSON ${handle}`); return r.json(); });
      PRODUCT_JSON.set(handle, p);
    }
    return p;
  }

  function hardSwapImg(imgEl, url) {
    if (!imgEl || !url) return imgEl;
    const clone = imgEl.cloneNode(true);
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.setAttribute('crossorigin', 'anonymous');
    clone.loading = 'eager';
    clone.decoding = 'async';
    clone.src = url;
    imgEl.replaceWith(clone);
    return clone;
  }

  function getPrimaryImg(mediaLink) {
    return mediaLink.querySelector('.product-card__image--primary') || mediaLink.querySelector('img');
  }

  function ensureSecondaryImg(mediaLink, primaryImg) {
    let secondary = mediaLink.querySelector('.product-card__image--secondary');
    if (!secondary) {
      secondary = primaryImg.cloneNode(true);
      secondary.classList.remove('product-card__image--primary');
      secondary.classList.add('product-card__image--secondary');
      secondary.removeAttribute('src');
      secondary.removeAttribute('srcset');
      secondary.removeAttribute('sizes');
      secondary.style.visibility = 'hidden';
      mediaLink.appendChild(secondary);
    }
    return secondary;
  }

  // multi currency helpers
  let __pat;
  const formatCents = (c, trim=true) => {
    if (!__pat) { __pat = (() => {
      const n = document.querySelector('sale-price'); // probe once
      if (!n) return { pre:'', suf:'', dec:'.' };
      const x = n.cloneNode(true);
      x.querySelectorAll('.sr-only,.visually-hidden').forEach(e=>e.remove());
      const t = x.textContent.trim();
      const m = t.match(/^(.*?)([\d.,\u00A0\u202F\s]+)(.*?)$/) || [, '', '', ''];
      const dec = (m[2].match(/([.,])\d{1,3}\s*$/)||[])[1] || '.';
      return { pre:m[1], suf:m[3], dec };
    })(); }
    const v = Math.abs(c||0)/100, neg = (c||0) < 0;
    const fd = trim && Math.round(v*100)%100===0 ? 0 : 2;
    const num = new Intl.NumberFormat(__pat.dec===',' ? 'de-DE' : 'en-US',
      { minimumFractionDigits: fd, maximumFractionDigits: fd }).format(v);
    return (neg?'-':'') + __pat.pre + num + __pat.suf;
  };

  function fmt(cents) {
    return formatCents(cents);
  }


  function setPrice(priceListEl, variant) {
    if (!priceListEl || !variant) return;
    const price = Number(variant.price);
    const compare = Number(variant.compare_at_price || 0);
    priceListEl.innerHTML = compare && compare > price
      ? `<sale-price class="text-on-sale"><span class="sr-only">Sale price</span>${fmt(price)}</sale-price><compare-at-price class="text-subdued line-through"><span class="sr-only">Regular price</span>${fmt(compare)}</compare-at-price>`
      : `<sale-price class="text-subdued"><span class="sr-only">Price</span>${fmt(price)}</sale-price>`;
  }

  function setLinks(card, url) {
    const mediaLink = card.querySelector('.product-card__media');
    const titleLink = card.querySelector('.product-title');
    if (mediaLink) mediaLink.href = url;
    if (titleLink) titleLink.href = url;
    const handle = url.split('/').pop();
    if (handle) card.setAttribute('handle', handle);
  }

  const getQuickModal = (card) =>
    card.querySelector('quick-buy-modal') || document.querySelector('quick-buy-modal');

  function setQuickView(card, handle, variantId, canonical) {
    const modal = getQuickModal(card);
    if (!modal) return;
    const value = variantId ? `${handle}?variant=${variantId}` : handle;
    modal.setAttribute('handle', value);
    if (canonical) modal.setAttribute('data-canonical', canonical);
  }

  // -------------------- BRA SIZE BADGE -------------------
  function getBraSize() {
    try {
      const c = document.cookie.split(';').map(s => s.trim()).find(s => s.startsWith('jfq_bra_sz='));
      return c ? JSON.parse(decodeURIComponent(c.slice('jfq_bra_sz='.length))) : null;
    } catch { return null; }
  }

  function normBraSize(s) {
    if (!s) return null;
    const m = /^(\d{2,3})\s*([A-Za-z]+)/i.exec(s.trim());
    if (!m) return null;
    let cup = m[2].toUpperCase().replace(/\/.*$/, '');
    if (cup === 'E') cup = 'DD';
    if (cup === 'F') cup = 'DDD';
    return m[1] + cup;
  }

  function updateBraBadge(card, braSize, availNorms) {
    card.querySelector('.product-card__media .jn-bra-badge')?.remove();
    resetMobileCta(card);
    if (!braSize) return;
    const target = normBraSize(braSize.full);
    if (!target) return;
    let matches, fittingSize = null;
    if (availNorms) {
      matches = availNorms.includes(target);
    } else {
      const attr = card.getAttribute('data-bra-szs');
      if (!attr) return;
      matches = attr.split(',').some(chunk => {
        const parts = chunk.split('|');
        if (normBraSize(parts[0]) === target || normBraSize(parts[1]) === target) return true;
        // Handle separate band/cup options e.g. option1="34" option2="DD/E"
        if (normBraSize((parts[0] || '') + (parts[1] || '')) === target) return true;
        // parts[2] is the fits metafield (bralette): colon-separated bra sizes e.g. "32B:32C:34A"
        if (parts[2] && parts[2].split(':').some(s => normBraSize(s) === target)) {
          fittingSize = (parts[0] || '').trim(); // garment size (e.g. "S/M") that fits this bra size
          return true;
        }
        return false;
      });
    }
    if (!matches) return;
    const media = card.querySelector('.product-card__media');
    if (!media) return;
    media.style.position = 'relative';
    const badge = document.createElement('div');
    badge.className = 'jn-bra-badge';
    badge.textContent = 'Your Size · ' + braSize.full;
    media.appendChild(badge);
    // For bralettes matched via fits metafield, pre-select the garment size (e.g. "S/M"),
    // not the bra size (which isn't a valid option in the bralette picker).
    if (fittingSize) {
      updateMobileCta(card, fittingSize, fittingSize.toLowerCase(), 'garment');
    } else {
      updateMobileCta(card, braSize.full, target, 'bra');
    }
  }

  if (!document.getElementById('jn-bra-badge-css')) {
    const st = document.createElement('style');
    st.id = 'jn-bra-badge-css';
    st.textContent = '.jn-bra-badge{position:absolute;bottom:10px;left:12px;padding:4px 10px;border:1px solid #3D1A5E;background:#fff;color:#3D1A5E;font-size:9px;font-family:inherit;letter-spacing:.12em;text-transform:uppercase;font-weight:700;pointer-events:none;z-index:2;line-height:1}.jn-panty-badge{position:absolute;bottom:10px;left:12px;padding:4px 10px;border:1px solid #3D1A5E;background:#fff;color:#3D1A5E;font-size:9px;font-family:inherit;letter-spacing:.12em;text-transform:uppercase;font-weight:700;pointer-events:none;z-index:2;line-height:1}';
    document.head.appendChild(st);
  }

  // -------------------- MOBILE CTA (Choose size / Add <size> to cart) -------------------
  function resetMobileCta(card) {
    card.removeAttribute('data-jn-cta-size');
    delete card.dataset.jnCtaAutosize;
    delete card.dataset.jnCtaSizeType;
    delete card.dataset.jnCtaDisplay;
    const cta = card.querySelector('.jn-mobile-choose-size');
    if (!cta) return;
    cta.textContent = 'Choose size';
    delete cta.dataset.jnAutosize;
    delete cta.dataset.jnSizeType;
    delete cta.dataset.jnDisplaySize;
  }

  function updateMobileCta(card, displaySize, normalizedSize, sizeType) {
    // Always store on the card so the desktop + button can read it even when
    // the mobile CTA element isn't rendered (jn_mobile_quick_add disabled).
    card.dataset.jnCtaAutosize = normalizedSize;
    card.dataset.jnCtaSizeType = sizeType;
    card.dataset.jnCtaDisplay = displaySize;
    const cta = card.querySelector('.jn-mobile-choose-size');
    // data-jn-cta-size hides the image badge on mobile (CSS) so only set it when
    // the CTA element actually exists to replace the badge.
    if (!cta) return;
    card.setAttribute('data-jn-cta-size', '1');
    const _safeSize = (displaySize || '').replace(/[<>&"']/g, '');
    cta.innerHTML = 'Add <strong>' + _safeSize + '</strong> to cart';
    cta.dataset.jnAutosize = normalizedSize;
    cta.dataset.jnSizeType = sizeType;
    cta.dataset.jnDisplaySize = displaySize;
  }

  // -------------------- CUP RANGE BADGE (fallback when no bra size cookie) -------------------
  function updateCupRangeBadge(card) {
    card.querySelector('.product-card__media .jn-bra-badge')?.remove();
    const range = card.getAttribute('data-cup-range');
    if (!range) return;
    const media = card.querySelector('.product-card__media');
    if (!media) return;
    media.style.position = 'relative';
    const badge = document.createElement('div');
    badge.className = 'jn-bra-badge';
    badge.textContent = range + ' Cups';
    media.appendChild(badge);
  }

  // -------------------- PANTY SIZE BADGE -------------------
  function getPantySizeData() {
    try {
      const c = document.cookie.split(';').map(s => s.trim()).find(s => s.startsWith('jfq_dress_sz='));
      const raw = c ? decodeURIComponent(c.slice('jfq_dress_sz='.length)) : (localStorage.getItem('jfq_dress_sz') || null);
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  }

  // Check if a dress size number falls within any range in a colon-separated fits string
  // e.g. dressFitsMatch('8-10:10-12', 8) => true
  function dressFitsMatch(fitsStr, dressSize) {
    if (!fitsStr || dressSize == null) return false;
    return fitsStr.split(':').some(part => {
      const m = /^(\d+)\s*[-–]\s*(\d+)$/.exec(part.trim());
      return m && dressSize >= parseInt(m[1], 10) && dressSize <= parseInt(m[2], 10);
    });
  }

  const PANTY_NORM_MAP = {
    'EXTRA SMALL':'XS','X-SMALL':'XS','X SMALL':'XS','SMALL':'S',
    'MEDIUM':'M','LARGE':'L','EXTRA LARGE':'XL','X-LARGE':'XL',
    'EXTRA EXTRA LARGE':'XXL','2XL':'XXL','3XL':'XXXL',
    'ONE SIZE':'OS','ONE SIZE FITS ALL':'OS','OSFM':'OS'
  };
  const PANTY_CANONICAL = new Set(['XS','S','M','L','XL','XXL','XXXL','OS']);

  function normPantySize(s) {
    if (!s) return null;
    const u = s.trim().toUpperCase();
    return PANTY_NORM_MAP[u] || (PANTY_CANONICAL.has(u) ? u : null);
  }

  function updatePantyBadge(card, pantyData, availSizes) {
    card.querySelector('.product-card__media .jn-panty-badge')?.remove();
    resetMobileCta(card);
    const pantySize = pantyData?.pantySize;
    const dressSize = typeof pantyData?.dressSize === 'number' ? pantyData.dressSize : null;
    if (!pantySize) return;
    let matched = false;
    if (availSizes !== null) {
      // Swatch-change path: only direct letter-size matching (no fits metafield in live JSON)
      matched = availSizes.some(s => s === pantySize.toUpperCase());
    } else {
      // initCard path: data-panty-szs is "opt1|opt2|fits_colon_sep,..."
      const attr = card.getAttribute('data-panty-szs') || '';
      matched = attr.split(',').some(chunk => {
        if (!chunk.trim()) return false;
        const parts = chunk.split('|');
        // Primary: dress size range match against custom.fits metafield
        if (dressSize != null && dressFitsMatch(parts[2], dressSize)) return true;
        // Fallback: direct letter-size match
        const s1 = normPantySize(parts[0]);
        const s2 = normPantySize(parts[1]);
        return (s1 && s1 === pantySize.toUpperCase()) || (s2 && s2 === pantySize.toUpperCase());
      });
    }
    if (!matched) return;
    const media = card.querySelector('.product-card__media');
    if (!media) return;
    media.style.position = 'relative';
    const badge = document.createElement('div');
    badge.className = 'jn-panty-badge';
    badge.textContent = 'Your Size · ' + pantySize;
    media.appendChild(badge);
    updateMobileCta(card, pantySize, pantySize.toUpperCase(), 'panty');
  }

  // -------------------- AVAILABLE-SIZES HOVER OVERLAY (desktop only) -------------------
  // Shows in-stock sizes over the card image on desktop hover. Bras show compact band/cup
  // ranges; everything else shows in-stock size chips. Reacts to swatch changes (re-rendered
  // from the fetched colourway JSON in the swatch handler). Mobile is untouched (CSS hides it).
  if (!document.getElementById('jn-size-overlay-css')) {
    const st = document.createElement('style');
    st.id = 'jn-size-overlay-css';
    st.textContent =
      // Static, on the image (bottom-left), desktop + mobile — replaces the old cup-range badge.
      '.jn-size-overlay{position:absolute;left:8px;right:8px;bottom:10px;display:flex;flex-wrap:wrap;justify-content:center;gap:3px;pointer-events:none;z-index:2}' +
      '.jn-size-overlay__chips{display:flex;flex-wrap:wrap;justify-content:center;gap:3px}' +
      '.jn-size-overlay__ranges,.jn-size-overlay__chip{padding:3px 5px;border:1px solid #3D1A5E;background:#fff;color:#3D1A5E;font-size:9px;letter-spacing:.04em;text-transform:uppercase;font-weight:700;line-height:1.1}' +
      '.jn-size-overlay__chip{white-space:nowrap}' +
      // Desktop: hidden until the card is hovered. Mobile is unaffected (stays visible).
      '@media (hover:hover) and (pointer:fine) and (min-width:1000px){.jn-size-overlay{opacity:0;transition:opacity .15s ease}product-card:hover .jn-size-overlay,.product-card:hover .jn-size-overlay{opacity:1}}';
    document.head.appendChild(st);
  }

  // Cup ranking treats European E/F as the equivalents of DD/DDD so a product that labels
  // its cups either way still orders correctly; the displayed label stays the product's own.
  const CUP_RANK = { AA: 0, A: 1, B: 2, C: 3, D: 4, DD: 5, E: 5, DDD: 6, F: 6, G: 7, H: 8, I: 9, J: 10, K: 11 };
  function cupKey(cup) {
    if (!cup) return -1;
    const u = String(cup).toUpperCase().trim().split('/')[0].replace(/\s+/g, '');
    return (u in CUP_RANK) ? CUP_RANK[u] : -1;
  }
  function uniq(arr) { return Array.from(new Set(arr)); }
  function escHtml(s) { return String(s).replace(/[<>&"']/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' }[c])); }

  // Parse "size|fits_colon_sep,..." -> [{size, fits:[...]}]
  function parseItemsAttr(attr) {
    if (!attr) return [];
    return attr.split(',').map(s => s.trim()).filter(Boolean).map(chunk => {
      const p = chunk.split('|');
      return { size: (p[0] || '').trim(), fits: (p[1] || '').split(':').map(x => x.trim()).filter(Boolean) };
    });
  }
  function buildFitsMap(attr) {
    const map = {};
    parseItemsAttr(attr).forEach(it => { if (it.size) map[it.size.toUpperCase()] = it.fits; });
    return map;
  }

  // A bra size token like "34C", "30DD", "34DD/E", "32DDD/F"
  function parseBraSize(s) {
    const m = /^(\d{2,3})\s*([A-Za-z]{1,3}(?:\/[A-Za-z])?)$/.exec(String(s || '').trim());
    return m ? { band: parseInt(m[1], 10), cup: m[2].toUpperCase() } : null;
  }

  // Collect bra-size tokens: the size itself if it's a bra size (true bras), else the garment
  // size's fits list (bralettes map a garment size to the bra sizes it fits).
  function braTokensFromItems(items) {
    const toks = [];
    items.forEach(it => {
      if (parseBraSize(it.size)) toks.push(it.size);
      else if (it.fits.length) it.fits.forEach(f => toks.push(f));
    });
    return toks;
  }

  function formatBraRanges(items) {
    const parsed = braTokensFromItems(items).map(parseBraSize).filter(Boolean);
    if (!parsed.length) return '';
    const out = [];
    const bands = uniq(parsed.map(p => p.band)).sort((a, b) => a - b);
    out.push('Bands ' + (bands.length === 1 ? bands[0] : bands[0] + '–' + bands[bands.length - 1]));
    const cups = uniq(parsed.map(p => p.cup)).filter(c => cupKey(c) >= 0).sort((a, b) => cupKey(a) - cupKey(b));
    if (cups.length) out.push('Cups ' + (cups.length === 1 ? cups[0] : cups[0] + '–' + cups[cups.length - 1]));
    return out.join(' · ');
  }

  // Order + abbreviate letter/word sizes (and numeric sizes) for the chip display.
  const SIZE_RANK = {
    'XXS': 0, 'EXTRA EXTRA SMALL': 0, 'XXS/XS': 5,
    'XS': 10, 'X-SMALL': 10, 'X SMALL': 10, 'EXTRA SMALL': 10, 'XS/S': 15,
    'S': 20, 'SMALL': 20, 'S/M': 25, 'SM': 25,
    'M': 30, 'MEDIUM': 30, 'M/L': 35, 'ML': 35,
    'L': 40, 'LARGE': 40, 'L/XL': 45,
    'XL': 50, 'X-LARGE': 50, 'X LARGE': 50, 'EXTRA LARGE': 50, 'XL/XXL': 55,
    'XXL': 60, 'XX-LARGE': 60, 'EXTRA EXTRA LARGE': 60, '2X': 60, '2XL': 60,
    'XXXL': 70, '3X': 70, '3XL': 70, 'OS': 900, 'ONE SIZE': 900, 'ONE SIZE FITS ALL': 900
  };
  const SIZE_ABBR = {
    'EXTRA SMALL': 'XS', 'X-SMALL': 'XS', 'X SMALL': 'XS', 'SMALL': 'S', 'MEDIUM': 'M', 'LARGE': 'L',
    'EXTRA LARGE': 'XL', 'X-LARGE': 'XL', 'X LARGE': 'XL', 'EXTRA EXTRA LARGE': 'XXL', 'XX-LARGE': 'XXL',
    'EXTRA EXTRA SMALL': 'XXS', 'ONE SIZE': 'OS', 'ONE SIZE FITS ALL': 'OS'
  };
  function sizeRank(s) {
    const u = String(s).toUpperCase().trim().replace(/\s*\/\s*/g, '/');
    if (u in SIZE_RANK) return SIZE_RANK[u];
    if (/^\d+$/.test(u)) return 1000 + parseInt(u, 10);
    return 2000;
  }
  function sizeDisplay(s) { const u = String(s).toUpperCase().trim(); return SIZE_ABBR[u] || s; }
  function formatChips(items) {
    const sizes = uniq(items.map(i => i.size).filter(Boolean).filter(s => s.toUpperCase() !== 'DEFAULT TITLE'));
    sizes.sort((a, b) => (sizeRank(a) - sizeRank(b)) || a.localeCompare(b));
    return sizes.map(sizeDisplay);
  }

  function renderSizeOverlay(card, items, isBra) {
    const media = card.querySelector('.product-card__media');
    if (!media) return;
    let html = '';
    if (isBra) {
      const txt = formatBraRanges(items);
      if (txt) html = '<span class="jn-size-overlay__ranges">' + escHtml(txt) + '</span>';
    } else {
      const chips = formatChips(items);
      if (chips.length) {
        html = '<span class="jn-size-overlay__chips">' +
          chips.map(s => '<span class="jn-size-overlay__chip">' + escHtml(s) + '</span>').join('') + '</span>';
      }
    }
    let ov = media.querySelector('.jn-size-overlay');
    if (!html) { if (ov) ov.remove(); return; }
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'jn-size-overlay';
      ov.setAttribute('aria-hidden', 'true'); // informational; the PDP carries authoritative sizes
      media.style.position = media.style.position || 'relative';
      media.appendChild(ov);
    }
    ov.innerHTML = html;
  }

  function removeSizeOverlay(card) {
    const ov = card.querySelector('.product-card__media .jn-size-overlay');
    if (ov) ov.remove();
  }

  // Build overlay items from a fetched colourway's product JSON (which has no metafields), using
  // the card's colourway-independent fits map to recover bralette bra-size coverage.
  function overlayItemsFromJSON(card, product) {
    const names = (product.options || []).map(n => String(n).toLowerCase());
    let sidx = names.findIndex(n => n.includes('size'));
    if (sidx < 0) sidx = names.findIndex(n => !n.includes('color') && !n.includes('colour'));
    if (sidx < 0) sidx = 0;
    const fitsMap = (card.__ovFitsMap || (card.__ovFitsMap = buildFitsMap(card.getAttribute('data-ov-fitsmap'))));
    return product.variants.filter(v => v.available).map(v => {
      const size = String((v.options && v.options[sidx]) || v.option1 || '').trim();
      return { size, fits: fitsMap[size.toUpperCase()] || [] };
    });
  }

  function initSizeOverlay(card) {
    renderSizeOverlay(card, parseItemsAttr(card.getAttribute('data-ov-szs')), card.getAttribute('data-ov-bra') === '1');
  }

  const _braSize = getBraSize();
  const _pantyData = getPantySizeData();

  // -------------------- SWATCH CHANGE -------------------
  document.addEventListener('change', async (ev) => {
    const t = ev.target;
    if (!(t instanceof Element)) return;

    const input = t.closest('input.js-sibling-swatch[type="radio"]');
    if (!input) return;

    const card = input.closest('product-card, .product-card');
    if (!card) return;

    const media = card.querySelector('.product-card__media');
    if (!media) return;

    let primary   = getPrimaryImg(media);
    let secondary = media.querySelector('.product-card__image--secondary');
    const priceEl = card.querySelector('price-list');
    const wishlistEl = card.querySelector('[data-jn-wishlist-heart]');

    const url     = input.dataset.url;
    const handle  = input.dataset.handle;
    const prefer  = input.dataset.preloadUrl || input.dataset.image || '';
    

    // 1) Update links immediately
    setLinks(card, url);

    // 2) Optimistic primary swap (instant)
    const firstUrl = sizeUrl(prefer, card);
    if (firstUrl) {
      warmImage(firstUrl);
      primary = hardSwapImg(primary, firstUrl);
    }

    // 3) Cancel any prior fetch for this card, then fetch JSON
    const prev = IN_FLIGHT.get(card);
    if (prev && typeof prev.abort === 'function') prev.abort();
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    IN_FLIGHT.set(card, controller);

    try {
      const product = await getProductJSON(handle, controller?.signal);
      if (IN_FLIGHT.get(card) !== controller) return;

      const variant = product.variants.find(v => v.available) || product.variants[0] || null;
      setPrice(priceEl, variant);

      const primaryJSON  = sizeUrl(product.images?.[0], card);
      const secondaryJSON = sizeUrl(product.images?.[1], card);

      if (primaryJSON) primary = hardSwapImg(primary, primaryJSON);

      if (secondaryJSON) {
        secondary = ensureSecondaryImg(media, primary);
        warmImage(secondaryJSON);
        secondary = hardSwapImg(secondary, secondaryJSON);
        secondary.style.visibility = '';
        media.classList.add('has-secondary');  // harmless if theme ignores it
      } else if (secondary) {
        secondary.removeAttribute('src');
        secondary.style.visibility = 'hidden';
        media.classList.remove('has-secondary');
      }

      const canonical = input.dataset.canonical || card.getAttribute('data-canonical') || '';
      setQuickView(card, handle, variant && variant.id, canonical);
      if (wishlistEl && product) {
        // Swatch changed the card's product → point the heart at the new product
        // and re-render its saved state from the custom wishlist cache.
        wishlistEl.setAttribute('data-wl-gid', 'gid://shopify/Product/' + product.id);
        if (handle) wishlistEl.setAttribute('data-wl-handle', handle);
        if (window.JNWishlist && typeof window.JNWishlist.syncHeart === 'function') {
          window.JNWishlist.syncHeart(wishlistEl);
        }
      }
      if (_braSize) {
        // product JSON has no metafields; use variant options only — empty array removes badge
        // rather than falling back to stale data-bra-szs from the original product
        const availNorms = product.variants
          .filter(v => v.available)
          .flatMap(v => [normBraSize(v.option1), normBraSize(v.option2), normBraSize(v.option1 + v.option2)])
          .filter(Boolean);
        updateBraBadge(card, _braSize, availNorms);
      }
      if (_pantyData?.pantySize && card.hasAttribute('data-panty-szs')) {
        const availPantySizes = product.variants
          .filter(v => v.available)
          .flatMap(v => [normPantySize(v.option1), normPantySize(v.option2)])
          .filter(Boolean);
        updatePantyBadge(card, _pantyData, availPantySizes.length ? availPantySizes : []);
      }
      // Availability sizing — re-render for the newly selected colourway, unless a size cookie is set
      {
        const braCookie = card.getAttribute('data-ov-bra') === '1' && !!_braSize;
        const pantyCookie = card.hasAttribute('data-panty-szs') && !!(_pantyData && _pantyData.pantySize);
        if (braCookie || pantyCookie) removeSizeOverlay(card);
        else renderSizeOverlay(card, overlayItemsFromJSON(card, product), card.getAttribute('data-ov-bra') === '1');
      }
    } catch(e) {
      console.log(e);
      setQuickView(card, handle, null, (input.dataset.canonical || card.getAttribute('data-canonical') || ''));
    } finally {
      if (IN_FLIGHT.get(card) === controller) IN_FLIGHT.delete(card);
    }
  });

  // -------------------- PRELOAD (approach + hover) -------------------
  const MAX_PRELOAD = 3; // selected + 2

  async function warmInput(card, input) {
    let raw = input.dataset.image;
    if (!raw) {
      try { const p = await getProductJSON(input.dataset.handle); raw = (p.images && p.images[0]) || ''; }
      catch {}
    }
    const u = sizeUrl(raw, card);
    input.dataset.preloadUrl = u;
    warmImage(u);

    // warm secondary if JSON is already cached
    try {
      const p = await PRODUCT_JSON.get(input.dataset.handle);
      const raw2 = p && p.images && p.images[1];
      if (raw2) warmImage(sizeUrl(raw2, card));
    } catch {}
  }

  function warmCard(card) {
    const inputs = Array.from(card.querySelectorAll('input.js-sibling-swatch'));
    if (!inputs.length) return;
    const selected = inputs.find(i => i.checked) || inputs[0];
    const rest = inputs.filter(i => i !== selected);
    const candidates = [selected, ...rest].slice(0, MAX_PRELOAD);
    candidates.forEach(i => warmInput(card, i));
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { warmCard(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '1000px 0px' });

  function initCard(card) {
    io.observe(card);
    const isBra = card.getAttribute('data-ov-bra') === '1';
    const braCookie = isBra && !!_braSize;
    const pantyCookie = card.hasAttribute('data-panty-szs') && !!(_pantyData && _pantyData.pantySize);
    // With a size cookie, keep the "Your Size" badge; otherwise the availability-based sizing
    // replaces the old cup-range badge (updateCupRangeBadge is no longer used).
    if (braCookie) updateBraBadge(card, _braSize, null);
    else if (pantyCookie) updatePantyBadge(card, _pantyData, null);
    if (braCookie || pantyCookie) removeSizeOverlay(card);
    else initSizeOverlay(card);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-card, .product-card').forEach(initCard);
  });

  // Re-badge cards injected after facet/filter updates
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (!(n instanceof HTMLElement)) continue;
        if (n.matches('product-card, .product-card')) {
          initCard(n);
        } else {
          n.querySelectorAll('product-card, .product-card').forEach(initCard);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('mouseover', (ev) => {
    const el = ev.target;
    if (!(el instanceof Element)) return;
    const label = el.closest('label.color-swatch');
    if (!label) return;
    const card  = label.closest('product-card, .product-card');
    if (!card) return;
    const inputId = label.getAttribute('for');
    const input = inputId && document.getElementById(inputId);
    if (!input) return;
    if (!input.dataset.prewarmed) { warmInput(card, input); input.dataset.prewarmed = '1'; }
  }, { passive: true });

  // -------------------- QUICK-BUY SIZE PRE-SELECT -------------------
  // When the "Add <size> to cart" CTA is clicked, store the pending size so we
  // can pre-select it once the quick-buy modal content finishes loading.
  let _jnPendingSize = null;
  let _jnPendingTimeout = null;

  document.addEventListener('click', (e) => {
    // Mobile CTA ("Add <size> to cart" button)
    const cta = e.target.closest('.jn-mobile-choose-size');
    if (cta && cta.dataset.jnAutosize) {
      clearTimeout(_jnPendingTimeout);
      _jnPendingSize = {
        normalized: cta.dataset.jnAutosize,
        display: cta.dataset.jnDisplaySize || cta.dataset.jnAutosize,
        type: cta.dataset.jnSizeType || 'bra'
      };
      _jnPendingTimeout = setTimeout(() => { _jnPendingSize = null; }, 5000);
      return;
    }
    // Desktop quick-add button (+ icon): pre-select if cookie size matches this product.
    // Size data is stored on the card element so it's available even when the mobile
    // CTA button isn't rendered (jn_mobile_quick_add section setting disabled).
    const qaBtn = e.target.closest('.product-card__quick-add-button');
    if (qaBtn) {
      const card = qaBtn.closest('product-card');
      if (!card || !card.dataset.jnCtaAutosize) return;
      clearTimeout(_jnPendingTimeout);
      _jnPendingSize = {
        normalized: card.dataset.jnCtaAutosize,
        display: card.dataset.jnCtaDisplay || card.dataset.jnCtaAutosize,
        type: card.dataset.jnCtaSizeType || 'bra'
      };
      _jnPendingTimeout = setTimeout(() => { _jnPendingSize = null; }, 5000);
    }
  });

  // Panty fallback: after rebuildSizes completes, find the radio by normalization
  // in case the cookie value and option text differ (e.g. "Medium" vs "M").
  function _jnPreselectPanty(content, pending) {
    const checked = content.querySelector('input[data-option-position="1"]:checked');
    if (checked) return; // canonicalSize seed already worked
    const target = pending.normalized;
    const inputs = content.querySelectorAll('input[data-option-position="1"]');
    for (const input of inputs) {
      if (normPantySize(input.value) === target) {
        const label = input.id && content.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        (label || input).click();
        break;
      }
    }
  }

  // Bralette / garment pre-select: direct case-insensitive match on option value.
  // Used when the fitting size is a garment size like "S/M" (not a bra band+cup).
  function _jnPreselectGarment(content, pending) {
    const target = pending.normalized.trim();
    const inputs = content.querySelectorAll('input[data-option-position="1"]');
    for (const input of inputs) {
      if ((input.value || '').toLowerCase().trim() === target) {
        const label = input.id && content.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        (label || input).click();
        break;
      }
    }
  }

  new MutationObserver((mutations) => {
    if (!_jnPendingSize) return;
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        const content = node.matches('.quick-buy-modal__content') ? node
          : node.querySelector('.quick-buy-modal__content');
        if (!content) continue;
        const pending = _jnPendingSize;
        _jnPendingSize = null;
        clearTimeout(_jnPendingTimeout);
        // Seed canonicalSize on the size button BEFORE jn-quickbuy-sibling-loader's
        // init() runs (init is deferred to rAF, so this synchronous code runs first).
        // rebuildSizes/buildBraPicker reads canonicalSize via getSizeText() to pick
        // the initial selection — covers both bra (parseBra) and panty (sameSize).
        const sizeBtn = content.querySelector('fieldset.variant-picker__option button.select');
        if (sizeBtn) sizeBtn.dataset.canonicalSize = pending.display;
        if (pending.type === 'panty') setTimeout(() => _jnPreselectPanty(content, pending), 350);
        // Bralette: garment size (e.g. "S/M") — skip canonicalSize, click the radio directly
        if (pending.type === 'garment') setTimeout(() => _jnPreselectGarment(content, pending), 350);
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // Recompute size cache on resize (deferred)
  let rAF;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(rAF);
    rAF = requestAnimationFrame(() => WIDTH_CACHE.clear());
  });
})();

/* custom wishlist: re-sync hearts after the product grid is swapped (filters/pagination) */
(function wishlistAfterFilters(){
  const canSync = () => window.JNWishlist && typeof window.JNWishlist.syncAll === 'function';

  let pending = false;
  function scheduleSync(){
    if (!canSync()) return;
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; window.JNWishlist.syncAll(); });
  }

  // Observe grid replacements (Prestige/S&D will swap these containers)
  const gridSelectors = ['.product-list'].join(',');

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type !== 'childList') continue;
      for (const n of m.addedNodes) {
        if (!(n instanceof HTMLElement)) continue;
        if (n.matches?.('[data-jn-wishlist-heart]')) { scheduleSync(); return; }
        if (n.matches?.(gridSelectors) || n.querySelector?.('[data-jn-wishlist-heart]')) { scheduleSync(); return; }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Also react to filter UI interactions (submit/change) and pagination
  document.addEventListener('change', (e) => {
    if (e.target.closest('facet-filters-form, [data-filters], form[action*="/collections/"], form[action*="/search"]')) {
      setTimeout(scheduleSync, 400);
    }
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('.Pagination, [data-load-more], [data-infinite-scroll], a[href*="page="]')) {
      setTimeout(scheduleSync, 400);
    }
  });

  // Initial bind
  if (document.readyState !== 'loading') scheduleSync();
  else document.addEventListener('DOMContentLoaded', scheduleSync);
})();